export enum SupportedLanguage {
  EN_US = 'en-US',
  EN_GB = 'en-GB',
  PT_BR = 'pt-BR',
}
